module.exports = __webpack_public_path__ + "static/img/xml_logo.8588ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xml_logo.png
// module id = EpNx
// module chunks = 151